import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { withRouter } from 'react-router-dom';
import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  IconButton,
  Button,
  Modal,
  Box,
  CircularProgress,
} from '@material-ui/core';
import {
  ExpandMore,
  EditOutlined,
  CloseOutlined,
  ChevronLeftOutlined
} from '@material-ui/icons/';
import clsx from 'clsx';
import {
  OrderHx,
  EditAllergies,
  EditMedications,
  EditHealthMaintenance,
  EditVaccinations,
  EditSocialHistory,
  EditFamilyHistory,
  EditAdvanceDirective,
  EditAdditionalItems
} from './';
import styles from '../../../style';
import moment from 'moment';
import { Roles } from 'util/enum';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Skeleton } from '@material-ui/lab';

const ScheduleAppo = props => {
  const { classes, loading, patientInfo, ptRemarks, remarks, role, ptActiveMedication, ptMedicalHistory, ptPastDiagnosis, ptInactiveDiagnosis, modalOpen } = props;

  // Data states
  const [loadallergy, setLoadAllergy] = useState(null);
  const [loadmedication, setLoadMedication] = useState(null);
  const [loadHealthMaintenance, setLoadHealthMaintenance] = useState(null);
  const [loadVaccination, setLoadVaccination] = useState(null);
  const [loadSocialHistory, setLoadSocialHistory] = useState(null);
  const [loadFamilyHistory, setLoadFamilyHistory] = useState(null);
  const [loadAdvanceDirectives, setLoadAdvanceDirectives] = useState(null);
  const [loadAdditionalItems, setLoadAdditionalItems] = useState(null);
  const [loadDiagnosis, setLoadDiagnosis] = useState(null);
  const [loadCpt, setLoadCpt] = useState(null);

  // Modal states
  const [openAllergy, setOpenAllergy] = useState(false);
  const [openOrderHx, setOpenOrderHx] = useState(false);
  const [openMedication, setOpenMedication] = useState(false);
  const [openHealthMaintenance, setOpenHealthMaintenance] = useState(false);
  const [openVaccinations, setOpenVaccinations] = useState(false);
  const [openSocialHistory, setOpenSocialHistory] = useState(false);
  const [openFamilyHistory, setOpenFamilyHistory] = useState(false);
  const [openAdvanceDirective, setOpenAdvanceDirective] = useState(false);
  const [openAdditionalItems, setOpenAdditionalItems] = useState(false);

  //#region OrderHx
  const handleOpenOrderHx = () => {
    setOpenOrderHx(true);
  };

  const handleCloseOrderHx = () => {
    setOpenOrderHx(false);
  };


  const renderOrderHx = () => (
    <Modal
      aria-describedby="simple-modal-description"
      aria-labelledby="simple-modal-title"
      disableBackdropClick
      onClose={handleCloseOrderHx}
      open={openOrderHx}
    >
      <Box className={classes.modalWrap} style={{ width: 650 }}>
        <Box className={classes.modalHead}>
          <Typography variant="h2">Order History</Typography>
          <IconButton
            aria-label="close"
            className={classes.modalClose}
            onClick={handleCloseOrderHx}
          >
            <CloseOutlined />
          </IconButton>
        </Box>

        {/* Fixed height content area — no more flickering */}
        <Box style={{ height: 480, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <OrderHx onCancel={handleCloseOrderHx} patientInfo={patientInfo} />
        </Box>
      </Box>
    </Modal>
  );

  //#endregion

  //#region Allergy
  useEffect(() => {
    if (ptMedicalHistory?.allergies !== undefined) {
      let allergy = [...ptMedicalHistory?.allergies];
      if (allergy.length > 0) {
        allergy.sort((a, b) => b.id - a.id);
      }
      setLoadAllergy(allergy);
    }
    if (ptMedicalHistory?.socialHistory !== undefined) {
      setLoadSocialHistory(ptMedicalHistory?.socialHistory);
    }
    if (ptMedicalHistory?.familyHistory !== undefined) {
      setLoadFamilyHistory(ptMedicalHistory?.familyHistory);
    }
    if (ptMedicalHistory?.healthMaintenance !== undefined) {
      setLoadHealthMaintenance(ptMedicalHistory?.healthMaintenance);
    }
    if (ptMedicalHistory?.vaccinations !== undefined) {
      setLoadVaccination(ptMedicalHistory?.vaccinations);
    }
    if (ptMedicalHistory?.advanceDirective !== undefined) {
      setLoadAdvanceDirectives(ptMedicalHistory?.advanceDirective);
    }
    if (ptMedicalHistory?.additionalItems !== undefined) {
      setLoadAdditionalItems(ptMedicalHistory?.additionalItems);
    }
  }, [ptMedicalHistory]);

  const _handleAllergyClick = event => {
    event.stopPropagation();
    handleOpenAllergy();
  };

  const handleOpenAllergy = () => {
    setOpenAllergy(true);
  };

  const handleCloseAllergy = () => {
    setOpenAllergy(false);
  };

  const getPatientName = () => {
    if (!patientInfo) return '';
    const { lastname = '', firstname = '', middleinitial = '' } = patientInfo;
    return `${lastname} ${firstname} ${middleinitial ? middleinitial : ''}`.trim();
  };

  const renderAllergy = () => {
    return (
      <Modal
        aria-describedby="simple-modal-description"
        aria-labelledby="simple-modal-title"
        disableBackdropClick
        onClose={handleCloseAllergy}
        open={openAllergy}
      >
        <Box className={classes.modalWrap} style={{ width: 750 }}>
          <Box className={classes.modalHead}>
            <Typography variant="h2">Allergies: {getPatientName()}</Typography>
            <IconButton
              aria-label="close"
              className={classes.modalClose}
              onClick={handleCloseAllergy}
            >
              <CloseOutlined />
            </IconButton>
          </Box>
          <EditAllergies
            onCancel={handleCloseAllergy}
            patientId={patientInfo?.id}
          />
        </Box>
      </Modal>
    );
  };
  //#endregion

  //#region Medications
  useEffect(() => {
    if (ptActiveMedication !== undefined) {
      setLoadMedication(ptActiveMedication);
    }
  }, [ptActiveMedication]);

  const _handleMedicationClick = event => {
    event.stopPropagation();
    handleOpenMedication();
  };

  const handleOpenMedication = () => {
    setOpenMedication(true);
  };

  const handleCloseMedication = () => {
    setOpenMedication(false);
  };

  const renderMedication = () => {
    return (
      <Modal
        aria-describedby="simple-modal-description"
        aria-labelledby="simple-modal-title"
        disableBackdropClick
        onClose={handleCloseMedication}
        open={openMedication}
      >
        <Box className={classes.modalWrap} style={{ width: 750 }}>
          <Box className={classes.modalHead}>
            <Typography variant="h2">Medications: {getPatientName()}</Typography>
            <IconButton
              aria-label="close"
              className={classes.modalClose}
              onClick={handleCloseMedication}
            >
              <CloseOutlined />
            </IconButton>
          </Box>
          <EditMedications
            onCancel={handleCloseMedication}
            patientId={patientInfo?.id}
          />
        </Box>
      </Modal>
    );
  };
  //#endregion

  //#region Health Maintenance 

  const _handleHealthMaintenanceClick = event => {
    event.stopPropagation();
    handleOpenHealthMaintenance();
  };

  const handleOpenHealthMaintenance = () => {
    setOpenHealthMaintenance(true);
  };

  const handleCloseHealthMaintenance = () => {
    setOpenHealthMaintenance(false);
  };

  const renderHealthMaintenance = () => {
    return (
      <Modal
        aria-describedby="simple-modal-description"
        aria-labelledby="simple-modal-title"
        disableBackdropClick
        onClose={handleCloseHealthMaintenance}
        open={openHealthMaintenance}
      >
        <Box className={classes.modalWrap} style={{ width: 750 }}>
          <Box className={classes.modalHead}>
            <Typography variant="h2">
              Health Maintenance: {getPatientName()}
            </Typography>
            <IconButton
              aria-label="close"
              className={classes.modalClose}
              onClick={handleCloseHealthMaintenance}
            >
              <CloseOutlined />
            </IconButton>
          </Box>
          <EditHealthMaintenance
            onCancel={handleCloseHealthMaintenance}
            patientId={patientInfo?.id}
          />
        </Box>
      </Modal>
    );
  };
  //#endregion

  //#region Vaccinations 

  const _handleVaccinationsClick = event => {
    event.stopPropagation();
    handleOpenVaccinations();
  };

  const handleOpenVaccinations = () => {
    setOpenVaccinations(true);
  };

  const handleCloseVaccinations = () => {
    setOpenVaccinations(false);
  };

  const renderVaccinations = () => {
    return (
      <Modal
        aria-describedby="simple-modal-description"
        aria-labelledby="simple-modal-title"
        disableBackdropClick
        onClose={handleCloseVaccinations}
        open={openVaccinations}
      >
        <Box className={classes.modalWrap} style={{ width: 750 }}>
          <Box className={classes.modalHead}>
            <Typography variant="h2">Vaccinations: {getPatientName()}</Typography>
            <IconButton
              aria-label="close"
              className={classes.modalClose}
              onClick={handleCloseVaccinations}
            >
              <CloseOutlined />
            </IconButton>
          </Box>
          <EditVaccinations
            onCancel={handleCloseVaccinations}
            patientId={patientInfo?.id}
          />
        </Box>
      </Modal>
    );
  };
  //#endregion

  //#region Social History 
  const _handleSocialHistoryClick = event => {
    event.stopPropagation();
    handleOpenSocialHistory();
  };

  const handleOpenSocialHistory = () => {
    setOpenSocialHistory(true);
  };

  const handleCloseSocialHistory = () => {
    setOpenSocialHistory(false);
  };

  const renderSocialHistory = () => {
    return (
      <Modal
        aria-describedby="simple-modal-description"
        aria-labelledby="simple-modal-title"
        disableBackdropClick
        onClose={handleCloseSocialHistory}
        open={openSocialHistory}
      >
        <Box className={classes.modalWrap} style={{ width: 750 }}>
          <Box className={classes.modalHead}>
            <Typography variant="h2">Social History: {getPatientName()}</Typography>
            <IconButton
              aria-label="close"
              className={classes.modalClose}
              onClick={handleCloseSocialHistory}
            >
              <CloseOutlined />
            </IconButton>
          </Box>
          <EditSocialHistory
            onCancel={handleCloseSocialHistory}
            patientId={patientInfo?.id}
          />
        </Box>
      </Modal>
    );
  };
  //#endregion

  //#region Family History 

  const _handleFamilyHistoryClick = event => {
    event.stopPropagation();
    handleOpenFamilyHistory();
  };

  const handleOpenFamilyHistory = () => {
    setOpenFamilyHistory(true);
  };

  const handleCloseFamilyHistory = () => {
    setOpenFamilyHistory(false);
  };

  const renderFamilyHistory = () => {
    return (
      <Modal
        aria-describedby="simple-modal-description"
        aria-labelledby="simple-modal-title"
        disableBackdropClick
        onClose={handleCloseFamilyHistory}
        open={openFamilyHistory}
      >
        <Box className={classes.modalWrap} style={{ width: 750 }}>
          <Box className={classes.modalHead}>
            <Typography variant="h2">Family History: {getPatientName()}</Typography>
            <IconButton
              aria-label="close"
              className={classes.modalClose}
              onClick={handleCloseFamilyHistory}
            >
              <CloseOutlined />
            </IconButton>
          </Box>
          <EditFamilyHistory
            patientId={patientInfo?.id}
            onCancel={handleCloseFamilyHistory}
          />
        </Box>
      </Modal>
    );
  };
  //#endregion

  //#region Advance Directives 

  const _handleAdvanceDirectiveClick = event => {
    event.stopPropagation();
    handleOpenAdvanceDirective();
  };

  const handleOpenAdvanceDirective = () => {
    setOpenAdvanceDirective(true);
  };

  const handleCloseAdvanceDirective = () => {
    setOpenAdvanceDirective(false);
  };

  const renderAdvanceDirective = () => {
    return (
      <Modal
        aria-describedby="simple-modal-description"
        aria-labelledby="simple-modal-title"
        disableBackdropClick
        onClose={handleCloseAdvanceDirective}
        open={openAdvanceDirective}
      >
        <Box className={classes.modalWrap} style={{ width: 750 }}>
          <Box className={classes.modalHead}>
            <Typography variant="h2">
              Advance Directives: {getPatientName()}
            </Typography>
            <IconButton
              aria-label="close"
              className={classes.modalClose}
              onClick={handleCloseAdvanceDirective}
            >
              <CloseOutlined />
            </IconButton>
          </Box>
          <EditAdvanceDirective
            onCancel={handleCloseAdvanceDirective}
            patientId={patientInfo?.id}
          />
        </Box>
      </Modal>
    );
  };
  //#endregion

  //#region Additional Items 

  const _handleAdditionalItemsClick = event => {
    event.stopPropagation();
    handleOpenAdditionalItems();
  };

  const handleOpenAdditionalItems = () => {
    setOpenAdditionalItems(true);
  };

  const handleCloseAdditionalItems = () => {
    setOpenAdditionalItems(false);
  };

  const renderAdditionalItems = () => {
    return (
      <Modal
        aria-describedby="simple-modal-description"
        aria-labelledby="simple-modal-title"
        disableBackdropClick
        onClose={handleCloseAdditionalItems}
        open={openAdditionalItems}
      >
        <Box className={classes.modalWrap} style={{ width: 750 }}>
          <Box className={classes.modalHead}>
            <Typography variant="h2">
              Additional Items: {getPatientName()}
            </Typography>
            <IconButton
              aria-label="close"
              className={classes.modalClose}
              onClick={handleCloseAdditionalItems}
            >
              <CloseOutlined />
            </IconButton>
          </Box>
          <EditAdditionalItems
            onCancel={handleCloseAdditionalItems}
            patientId={patientInfo?.id}
          />
        </Box>
      </Modal>
    );
  };
  //#endregion

  //#region Past Diagnosis && CPT
  useEffect(() => {
    if (ptPastDiagnosis !== undefined) {
      let pastDiag = ptPastDiagnosis?.filter(c => c.codeType === 'diagnosis' && c.isActive)
      let pastCpt = ptPastDiagnosis?.filter(c => c.codeType === 'cpt' && c.isActive) || [];
      setLoadCpt(pastCpt);
      setLoadDiagnosis(pastDiag);
    }
  }, [ptPastDiagnosis]);

  const handleCopyfromMHx = (item, type) => {
    if (type === 'diagnosis') {
      props.handleCopy([item], []);
    } else {
      props.handleCopy([], [item]);
    }
  };
  //#endregion

  const renderClinicalFindings = () => {
    if (role === Roles.patient) {
      return remarks && remarks?.length > 0
        ? remarks
          .filter(c => c.isActive === true && c.remarks !== null)
          .sort((a, b) => b.id - a.id)
          .map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.remarks}</TableCell>
              <TableCell>
                {item.updatedDate
                  ? moment(item.updatedDate).format('MM/DD/YYYY')
                  : ''}
              </TableCell>
            </TableRow>
          ))
        : null;
    }
    return ptRemarks?.length > 0
      ? ptRemarks
        .filter(c => c.isActive === true && c.remarks !== null)
        .sort((a, b) => b.id - a.id)
        .map((item, index) => (
          <TableRow key={index}>
            <TableCell>{item.remarks}</TableCell>
            <TableCell>
              {item.updatedDate
                ? moment(item.updatedDate).format('MM/DD/YYYY')
                : ''}
            </TableCell>
          </TableRow>
        ))
      : null;
  };

  const TableRowsLoader = ({ rowsNum = 15 }) => (
    <>
      {[...Array(rowsNum)].map((_, index) => (
        <TableRow key={index}>
          <TableCell align="center">
            <Skeleton animation="wave" variant="text" />
          </TableCell>
          <TableCell align="center">
            <Skeleton animation="wave" variant="text" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );

  return (
    <Grid className={classes.rightWrap} item xs={12}>
      <PerfectScrollbar style={{ overflowX: 'hidden' }}>
        <div className={classes.MHXwrap}>
          <div className={classes.sectionHeader}>
            Medical Hx Summary
            {!props.isViewSoap && (
              <Button
                color="primary"
                onClick={handleOpenOrderHx}
                size="small"
                variant="text"
              >
                Order Hx
              </Button>
            )}
          </div>

          {/* Allergies Section */}
          <ExpansionPanel className={classes.accordionWrap} defaultExpanded>
            <ExpansionPanelSummary
              aria-controls="panel-allergies-content"
              className={classes.accordionHeader}
              expandIcon={<ExpandMore />}
              id="panel-allergies-header"
              style={{ alignItems: 'center' }}
            >
              <Typography className={classes.heading}>Allergies</Typography>
              {!props.isViewSoap && (
                <IconButton onClick={_handleAllergyClick} size="small">
                  <EditOutlined />
                </IconButton>
              )}
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Table className={clsx(classes.plainTable, classes.allergyTable)}>
                <TableBody>
                  {!_.isEmpty(loadallergy) &&
                    _.map(loadallergy, (item, index) => (
                      <TableRow key={index}>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.reaction}</TableCell>
                      </TableRow>
                    ))}
                  {!loadallergy &&
                    <TableRowsLoader rowsNum={3} />
                  }
                </TableBody>
              </Table>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          {/* Medications Section */}
          <ExpansionPanel className={classes.accordionWrap} defaultExpanded>
            <ExpansionPanelSummary
              aria-controls="panel-medications-content"
              className={classes.accordionHeader}
              expandIcon={<ExpandMore />}
              id="panel-medications-header"
            >
              <Typography className={classes.heading}>Medications</Typography>
              {!props.isViewSoap && (
                <IconButton onClick={_handleMedicationClick} size="small">
                  <EditOutlined />
                </IconButton>
              )}
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Table className={clsx(classes.plainTable, classes.medicTable)}>
                <TableBody>
                  {!_.isEmpty(loadmedication) &&
                    loadmedication
                      .filter(c => c.isActive === true)
                      .sort((a, b) => b.id - a.id)
                      .map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{item.name}</TableCell>
                          <TableCell>{item.dose}</TableCell>
                          <TableCell>{item.directions}</TableCell>
                        </TableRow>
                      ))}
                  {!loadmedication &&
                    <TableRowsLoader rowsNum={3} />
                  }
                </TableBody>
              </Table>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          {/* Clinical Findings Section */}
          <ExpansionPanel className={classes.accordionWrap} defaultExpanded>
            <ExpansionPanelSummary
              aria-controls="panel-findings-content"
              className={classes.accordionHeader}
              expandIcon={<ExpandMore />}
              id="panel-findings-header"
            >
              <Typography className={classes.heading}>
                Clinical Findings
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Table className={classes.plainTable}>
                <TableBody>
                  {renderClinicalFindings()}
                   {!ptRemarks && !remarks && 
                    <TableRowsLoader rowsNum={2} />
                  }
                </TableBody>
              </Table>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          {/* Health Maintenance Section */}
          <ExpansionPanel className={classes.accordionWrap} defaultExpanded>
            <ExpansionPanelSummary
              aria-controls="panel-health-content"
              className={classes.accordionHeader}
              expandIcon={<ExpandMore />}
              id="panel-health-header"
            >
              <Typography className={classes.heading}>
                Health Maintenance
              </Typography>
              {!props.isViewSoap && (
                <IconButton onClick={_handleHealthMaintenanceClick} size="small">
                  <EditOutlined />
                </IconButton>
              )}
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Table className={clsx(classes.plainTable, classes.healthMaint)}>
                <TableBody>
                  {loadHealthMaintenance &&
                    loadHealthMaintenance.length > 0 &&
                    loadHealthMaintenance
                      .sort((a, b) => b.id - a.id)
                      .map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{item.name}</TableCell>
                          <TableCell>
                            {item.recordedDate
                              ? moment(item.recordedDate).format('MM/DD/YYYY')
                              : ''}
                          </TableCell>
                          <TableCell>{item.findings}</TableCell>
                        </TableRow>
                      ))}
                  {!loadHealthMaintenance &&
                    <TableRowsLoader rowsNum={3} />
                  }
                </TableBody>
              </Table>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          {/* Past Diagnosis Section - Non-Patient Only */}
          {role !== Roles.patient && (
            <>
              <ExpansionPanel className={classes.accordionWrap} defaultExpanded>
                <ExpansionPanelSummary
                  aria-controls="panel-diagnosis-content"
                  className={classes.accordionHeader}
                  expandIcon={<ExpandMore />}
                  id="panel-diagnosis-header"
                >
                  <Typography className={classes.heading}>
                    Past Diagnosis
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Table
                    className={clsx(classes.plainTable, classes.pastDiagTable)}
                  >
                    <TableBody>
                      {loadDiagnosis &&
                        loadDiagnosis.length > 0 &&
                        loadDiagnosis
                          .sort((a, b) => b.id - a.id)
                          .map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                <IconButton color="primary" size="small">
                                  <ChevronLeftOutlined
                                    className={classes.iconBlue}
                                    onClick={() =>
                                      handleCopyfromMHx(item, 'diagnosis')
                                    }
                                  />
                                </IconButton>
                              </TableCell>
                              <TableCell>{item.code}</TableCell>
                              <TableCell>{item.description}</TableCell>
                            </TableRow>
                          ))}
                      {!loadDiagnosis &&
                        <TableRowsLoader rowsNum={3} />
                      }
                    </TableBody>
                  </Table>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              {/* CPT Section */}
              <ExpansionPanel className={classes.accordionWrap} defaultExpanded>
                <ExpansionPanelSummary
                  aria-controls="panel-cpt-content"
                  className={classes.accordionHeader}
                  expandIcon={<ExpandMore />}
                  id="panel-cpt-header"
                >
                  <Typography className={classes.heading}>CPT</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Table className={classes.plainTable}>
                    <TableBody>
                      {loadCpt &&
                        loadCpt.length > 0 &&
                        loadCpt
                          .sort((a, b) => b.id - a.id)
                          .map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                <IconButton color="primary" size="small">
                                  <ChevronLeftOutlined
                                    className={classes.iconBlue}
                                    onClick={() => handleCopyfromMHx(item, 'cpt')}
                                  />
                                </IconButton>
                              </TableCell>
                              <TableCell>{item.code}</TableCell>
                              <TableCell>{item.description}</TableCell>
                            </TableRow>
                          ))}
                      {!loadCpt &&
                        <TableRowsLoader rowsNum={3} />
                      }
                    </TableBody>
                  </Table>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </>
          )}

          {/* Vaccinations Section */}
          <ExpansionPanel className={classes.accordionWrap} defaultExpanded>
            <ExpansionPanelSummary
              aria-controls="panel-vaccinations-content"
              className={classes.accordionHeader}
              expandIcon={<ExpandMore />}
              id="panel-vaccinations-header"
            >
              <Typography className={classes.heading}>Vaccinations</Typography>
              {!props.isViewSoap && (
                <IconButton onClick={_handleVaccinationsClick} size="small">
                  <EditOutlined />
                </IconButton>
              )}
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Table className={clsx(classes.plainTable, classes.vaccination)}>
                <TableBody>
                  {loadVaccination &&
                    loadVaccination.length > 0 &&
                    loadVaccination
                      .sort((a, b) => b.id - a.id)
                      .map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{item.name}</TableCell>
                          <TableCell>
                            {item.dategiven
                              ? moment(item.dategiven).format('MM/DD/YYYY')
                              : ''}
                          </TableCell>
                          <TableCell>{item.lot}</TableCell>
                        </TableRow>
                      ))}
                  {!loadVaccination &&
                    <TableRowsLoader rowsNum={3} />
                  }
                </TableBody>
              </Table>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          {/* Non-Patient Sections */}
          {role !== Roles.patient && (
            <>
              {/* Social History Section */}
              <ExpansionPanel className={classes.accordionWrap} defaultExpanded>
                <ExpansionPanelSummary
                  aria-controls="panel-social-content"
                  className={classes.accordionHeader}
                  expandIcon={<ExpandMore />}
                  id="panel-social-header"
                >
                  <Typography className={classes.heading}>
                    Social History
                  </Typography>
                  {!props.isViewSoap && (
                    <IconButton onClick={_handleSocialHistoryClick} size="small">
                      <EditOutlined />
                    </IconButton>
                  )}
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Table
                    className={clsx(classes.plainTable, classes.socialHTable)}
                  >
                    <TableBody>
                      {loadSocialHistory &&
                        loadSocialHistory.length > 0 &&
                        loadSocialHistory
                          .sort((a, b) => b.id - a.id)
                          .map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>{item.description}</TableCell>
                            </TableRow>
                          ))}
                      {!loadSocialHistory &&
                        <TableRowsLoader rowsNum={3} />
                      }
                    </TableBody>
                  </Table>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              {/* Family History Section */}
              <ExpansionPanel className={classes.accordionWrap} defaultExpanded>
                <ExpansionPanelSummary
                  aria-controls="panel-family-content"
                  className={classes.accordionHeader}
                  expandIcon={<ExpandMore />}
                  id="panel-family-header"
                >
                  <Typography className={classes.heading}>
                    Family History
                  </Typography>
                  {!props.isViewSoap && (
                    <IconButton onClick={_handleFamilyHistoryClick} size="small">
                      <EditOutlined />
                    </IconButton>
                  )}
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Table
                    className={clsx(classes.plainTable, classes.FamilyHistory)}
                  >
                    <TableBody>
                      {loadFamilyHistory &&
                        loadFamilyHistory.length > 0 &&
                        loadFamilyHistory
                          .sort((a, b) => b.id - a.id)
                          .map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>{item.description}</TableCell>
                            </TableRow>
                          ))}
                      {!loadFamilyHistory &&
                        <TableRowsLoader rowsNum={3} />
                      }
                    </TableBody>
                  </Table>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              {/* Advance Directives Section */}
              <ExpansionPanel className={classes.accordionWrap} defaultExpanded>
                <ExpansionPanelSummary
                  aria-controls="panel-advance-content"
                  className={classes.accordionHeader}
                  expandIcon={<ExpandMore />}
                  id="panel-advance-header"
                >
                  <Typography className={classes.heading}>
                    Advance Directives
                  </Typography>
                  {!props.isViewSoap && (
                    <IconButton
                      onClick={_handleAdvanceDirectiveClick}
                      size="small"
                    >
                      <EditOutlined />
                    </IconButton>
                  )}
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Table className={classes.plainTable}>
                    <TableBody>
                      {loadAdvanceDirectives &&
                        loadAdvanceDirectives.length > 0 &&
                        loadAdvanceDirectives
                          .sort((a, b) => b.id - a.id)
                          .map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>{item.description}</TableCell>
                            </TableRow>
                          ))}
                      {!loadAdvanceDirectives &&
                        <TableRowsLoader rowsNum={3} />
                      }
                    </TableBody>
                  </Table>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              {/* Additional Items Section */}
              <ExpansionPanel className={classes.accordionWrap} defaultExpanded>
                <ExpansionPanelSummary
                  aria-controls="panel-additional-content"
                  className={classes.accordionHeader}
                  expandIcon={<ExpandMore />}
                  id="panel-additional-header"
                >
                  <Typography className={classes.heading}>
                    Additional Items
                  </Typography>
                  {!props.isViewSoap && (
                    <IconButton onClick={_handleAdditionalItemsClick} size="small">
                      <EditOutlined />
                    </IconButton>
                  )}
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Table className={classes.plainTable}>
                    <TableBody>
                      {loadAdditionalItems &&
                        loadAdditionalItems.length > 0 &&
                        loadAdditionalItems
                          .sort((a, b) => b.id - a.id)
                          .map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>{item.description}</TableCell>
                            </TableRow>
                          ))}
                      {!loadAdditionalItems &&
                        <TableRowsLoader rowsNum={3} />
                      }
                    </TableBody>
                  </Table>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </>
          )}
        </div>
      </PerfectScrollbar>

      {/* Render Modals */}
      {openOrderHx && renderOrderHx()}
      {openAllergy && renderAllergy()}
      {openMedication && renderMedication()}
      {openHealthMaintenance && renderHealthMaintenance()}
      {openVaccinations && renderVaccinations()}
      {openSocialHistory && renderSocialHistory()}
      {openFamilyHistory && renderFamilyHistory()}
      {openAdvanceDirective && renderAdvanceDirective()}
      {openAdditionalItems && renderAdditionalItems()}
    </Grid>
  );
};

ScheduleAppo.propTypes = {
  className: PropTypes.string,
  allergies: PropTypes.array,
  medication: PropTypes.array,
  inactivemedication: PropTypes.array,
  healthMaintenance: PropTypes.array,
  vaccinations: PropTypes.array,
  socialHistory: PropTypes.array,
  familyHistory: PropTypes.array,
  advanceDirectives: PropTypes.array,
  additionalItems: PropTypes.array,
  diagnosis: PropTypes.array,
  cpt: PropTypes.array,
  isViewSoap: PropTypes.bool,
  getAllergy: PropTypes.func,
  getMedication: PropTypes.func,
  getInactiveMedication: PropTypes.func,
  getHealthMaintenance: PropTypes.func,
  getVaccination: PropTypes.func,
  getSocialHistory: PropTypes.func,
  getFamilyHistory: PropTypes.func,
  getAdvanceDirectives: PropTypes.func,
  getAdditionalItems: PropTypes.func,
  handleCopy: PropTypes.func
};

const mapStateToProps = state => ({
  role: state.profile?.role,
  remarks: state.soap?.patientInfo?.remarks,
  ehrID: state.profile && state.profile.ehrID,
  userID: state.profile && state.profile.userID,
  patientInfo: state.soap && state.soap.patientInfo,
  ptInactiveMedication: state.soap && state.soap.ptInactiveMedication,
  ptActiveMedication: state.soap && state.soap.ptActiveMedication,
  ptMedicalHistory: state.soap && state.soap.ptMedicalHistory,
  ptPastDiagnosis: state.soap && state.soap.ptPastDiagnosis,
  ptInactiveDiagnosis: state.soap && state.soap.ptInactiveDiagnosis,
  ptRemarks: state.soap && state.soap.ptRemarks,
});

const mapDispatchToProps = {}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ScheduleAppo))
);